var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _g4, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _path22, _path23, _path24, _path25, _g6, _path26, _path27, _path28, _path29, _path30, _g7, _path31, _path32, _path33, _path34, _g8, _path35, _path36, _path37, _path38, _path39, _g9, _path40, _path41, _path42, _path43, _g10, _path44, _path45, _path46, _path47, _path48, _g11, _path49, _path50, _path51, _path52, _g12, _path53, _path54, _path55, _path56, _g13, _path57, _path58, _path59, _path60, _g14, _path61, _path62, _path63, _path64, _path65, _g15, _path66, _path67, _path68, _path69, _g16, _path70, _path71, _path72, _path73, _g17, _path74, _path75, _path76, _path77, _path78, _g18, _path79, _path80, _path81, _path82, _path83, _g19, _path84, _path85, _g20, _path86, _path87, _g21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 772,
    height: 720,
    viewBox: "0 0 772 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 720,
    height: 720
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H719.589V719.583H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 720,
    height: 720
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.797 0C161.089 0 0 161.083 0 359.792C0 558.5 161.089 719.583 359.797 719.583C558.505 719.583 719.589 558.5 719.589 359.792C719.589 161.083 558.505 0 359.797 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V719.583H719.589V0H0Z",
    fill: "url(#paint0_radial_49_1590)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 506,
    y: 319,
    width: 24,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M506.104 319.348H529.831V363.055H506.104V319.348Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.767 320.143L509.221 362.162L506.119 362.367L526.733 320.377L529.767 320.143Z",
    fill: "#4E4E4E"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 169,
    width: 411,
    height: 195
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.741 169.498H527.333V363.055H117.741V169.498Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.714 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.714 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.714 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 170,
    width: 410,
    height: 193
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M522.597 313.739L473.105 240.535C472.646 239.881 472.261 239.267 471.807 238.618C471.666 238.374 471.495 238.208 471.354 237.964C471.037 237.555 470.725 237.145 470.407 236.735C470.198 236.462 470.061 236.223 469.817 236.018C469.568 235.643 469.256 235.233 468.978 234.925C468.768 234.652 468.559 234.374 468.349 234.101C468.1 233.726 467.822 233.418 467.51 233.008C467.3 232.735 467.09 232.462 466.881 232.189C466.598 231.882 466.354 231.506 466.076 231.199C465.866 230.926 465.656 230.652 465.378 230.345C465.095 230.038 464.851 229.657 464.573 229.35C464.364 229.077 464.086 228.77 463.876 228.496C463.598 228.189 463.315 227.882 463.003 227.472C462.793 227.199 462.515 226.891 462.271 226.687C462.095 226.516 461.886 226.243 461.71 226.072C461.642 226.038 461.539 225.901 461.466 225.867C460.734 225.082 460.071 224.331 459.305 223.618C459.203 223.482 459.134 223.448 459.027 223.311C458.398 222.662 457.705 221.979 457.076 221.331C456.832 221.126 456.656 220.955 456.447 220.682C455.754 219.999 455.057 219.321 454.359 218.638C454.291 218.604 454.183 218.467 454.115 218.433C453.349 217.716 452.515 216.965 451.749 216.253C451.676 216.219 451.574 216.082 451.505 216.048C451.33 215.877 451.154 215.706 451.018 215.638C450.598 215.262 450.11 214.858 449.696 214.482C449.383 214.243 449.14 214.038 448.862 213.731C448.442 213.355 447.954 212.945 447.535 212.575C447.223 212.336 446.979 212.131 446.666 211.892C446.184 211.482 445.696 211.077 445.208 210.667C444.964 210.463 444.72 210.258 444.476 210.053C443.745 209.443 442.984 208.897 442.252 208.287C441.554 207.775 440.828 207.165 440.13 206.653C439.886 206.448 439.613 206.316 439.369 206.111C438.847 205.77 438.428 205.394 437.911 205.058C437.593 204.819 437.35 204.614 437.003 204.448C436.554 204.141 436.101 203.833 435.686 203.458C435.374 203.224 435.057 202.985 434.711 202.814C434.262 202.511 433.808 202.204 433.428 201.931C433.359 201.897 433.291 201.868 433.218 201.833C432.906 201.594 432.628 201.458 432.316 201.219C431.935 200.951 431.555 200.677 431.135 200.472C430.755 200.204 430.34 199.999 430.028 199.76C429.642 199.492 429.228 199.287 428.847 199.019C428.462 198.746 428.047 198.541 427.667 198.273C427.286 197.999 426.867 197.795 426.486 197.526C426.106 197.253 425.686 197.053 425.306 196.78C424.925 196.507 424.511 196.307 424.125 196.034C424.057 195.999 423.921 195.931 423.847 195.897C423.501 195.731 423.257 195.526 422.911 195.356C422.496 195.156 422.116 194.882 421.701 194.677C421.282 194.477 420.901 194.204 420.486 194.004C420.067 193.799 419.686 193.531 419.272 193.326C418.857 193.126 418.472 192.853 418.057 192.648C417.643 192.448 417.262 192.175 416.843 191.975C416.428 191.77 416.013 191.57 415.628 191.297C415.213 191.092 414.799 190.892 414.418 190.619C414.345 190.585 414.209 190.517 414.14 190.487C413.726 190.282 413.238 190.048 412.823 189.843C412.545 189.707 412.267 189.575 412.062 189.473C411.228 189.068 410.467 188.697 409.633 188.292C408.662 187.819 407.765 187.38 406.794 186.907C406.516 186.775 406.17 186.604 405.892 186.468C405.267 186.165 404.575 185.829 403.916 185.595C403.779 185.526 403.643 185.458 403.501 185.39C403.292 185.292 403.087 185.19 402.877 185.087C402.326 184.819 401.736 184.619 401.253 184.38C400.906 184.214 400.453 184.078 400.106 183.912C399.555 183.639 398.965 183.439 398.482 183.205C398.136 183.034 397.755 182.936 397.409 182.766C396.819 182.566 396.263 182.297 395.609 182.063C395.263 181.892 394.95 181.829 394.604 181.658C393.877 181.39 393.219 181.156 392.492 180.888C392.282 180.785 392.146 180.722 391.902 180.688L391.833 180.653C390.829 180.253 389.794 179.917 388.755 179.585C388.477 179.449 388.165 179.385 387.892 179.249C387.092 178.946 386.331 178.746 385.536 178.444C385.224 178.38 384.951 178.244 384.57 178.146C383.599 177.844 382.702 177.58 381.731 177.278C381.663 177.244 381.526 177.175 381.424 177.214C380.385 176.878 379.312 176.614 378.346 176.317C378.273 176.283 378.136 176.214 378.034 176.249C377.721 176.185 377.443 176.049 377.204 176.014C376.756 175.883 376.302 175.751 375.853 175.614C375.473 175.517 375.024 175.385 374.643 175.283C374.195 175.151 373.746 175.019 373.263 174.956C372.883 174.853 372.434 174.722 372.053 174.624C371.604 174.488 371.122 174.424 370.668 174.293C370.287 174.195 369.839 174.058 369.424 174.029C368.975 173.897 368.492 173.834 368.044 173.697C367.663 173.6 367.18 173.536 366.8 173.439C366.351 173.302 365.868 173.239 365.488 173.141C365.107 173.039 364.692 173.01 364.244 172.878C363.761 172.814 363.38 172.712 362.897 172.649C362.517 172.551 362.102 172.522 361.653 172.385C361.171 172.322 360.79 172.224 360.307 172.161C359.893 172.132 359.512 172.029 359.097 172C358.615 171.936 358.234 171.839 357.751 171.775C357.507 171.741 357.268 171.707 357.024 171.678C356.785 171.644 356.541 171.615 356.302 171.58C356.058 171.551 355.888 171.551 355.644 171.522C354.922 171.424 354.195 171.327 353.4 171.2C352.678 171.102 351.951 171.005 351.19 170.98C350.951 170.946 350.781 170.951 350.537 170.917C349.951 170.888 349.4 170.79 348.742 170.732C348.571 170.732 348.429 170.663 348.259 170.668C347.532 170.571 346.776 170.541 346.122 170.483C345.946 170.483 345.776 170.483 345.634 170.419C345.049 170.39 344.464 170.361 343.878 170.332C343.707 170.336 343.464 170.302 343.293 170.302C342.532 170.278 341.878 170.215 341.117 170.19C340.429 170.195 339.669 170.171 338.981 170.176C338.81 170.18 338.566 170.146 338.395 170.146C337.81 170.122 337.293 170.127 336.673 170.166C336.498 170.171 336.327 170.171 336.156 170.171C335.464 170.18 334.776 170.185 334.088 170.195C333.913 170.195 333.742 170.195 333.639 170.234C333.122 170.239 332.503 170.278 331.986 170.283C331.81 170.288 331.639 170.288 331.366 170.327C330.674 170.332 329.952 170.41 329.332 170.449L187.525 180.858C186.906 180.897 186.281 180.936 185.73 181.014C185.628 181.048 185.559 181.014 185.525 181.083C185.076 181.122 184.632 181.161 184.252 181.234C183.906 181.239 183.598 181.346 183.252 181.351C182.808 181.39 182.359 181.429 181.979 181.502C181.706 181.536 181.325 181.609 181.052 181.648C180.603 181.687 180.12 181.795 179.677 181.834C179.398 181.873 179.125 181.907 178.847 181.946C178.364 182.053 177.818 182.131 177.335 182.239C177.13 182.307 176.886 182.278 176.681 182.346C175.925 182.492 175.272 182.605 174.584 182.785C174.481 182.819 174.374 182.853 174.306 182.819C173.721 182.966 173.067 183.073 172.486 183.219C172.277 183.287 172.003 183.326 171.799 183.4C171.316 183.507 170.901 183.648 170.525 183.722C170.247 183.761 170.008 183.897 169.735 183.936C169.321 184.078 168.945 184.151 168.53 184.292L168.428 184.331C167.916 184.507 167.433 184.614 166.916 184.795C166.813 184.829 166.711 184.863 166.506 184.936C166.023 185.044 165.579 185.253 165.165 185.4C165.062 185.434 164.96 185.468 164.857 185.502C164.34 185.683 163.794 185.926 163.277 186.107C163.174 186.141 163.072 186.175 162.935 186.283C162.487 186.492 162.077 186.634 161.628 186.848C161.526 186.883 161.423 186.917 161.321 186.956C160.804 187.131 160.326 187.414 159.813 187.59C159.706 187.624 159.604 187.663 159.467 187.765C159.262 187.839 159.023 187.975 158.818 188.048C158.574 188.19 158.335 188.331 158.062 188.365L157.96 188.404C157.477 188.682 157.033 188.892 156.555 189.175C156.453 189.209 156.418 189.278 156.311 189.317C155.833 189.595 155.389 189.809 154.979 190.121C154.877 190.156 154.843 190.229 154.74 190.263C154.257 190.541 153.882 190.79 153.404 191.068C153.37 191.136 153.267 191.175 153.267 191.175C152.784 191.453 152.375 191.77 151.897 192.048C151.384 192.399 150.975 192.717 150.458 193.063C150.321 193.17 150.184 193.273 150.048 193.38C149.74 193.658 149.399 193.834 149.092 194.112C148.921 194.287 148.784 194.39 148.545 194.531C148.272 194.741 147.999 194.951 147.794 195.195C147.623 195.37 147.453 195.541 147.214 195.682C146.941 195.892 146.736 196.136 146.463 196.346C146.463 196.346 146.428 196.414 146.36 196.38C146.189 196.556 146.019 196.731 145.848 196.902C145.677 197.077 145.472 197.321 145.233 197.463C145.063 197.634 144.858 197.877 144.687 198.053C144.516 198.229 144.311 198.473 144.141 198.643C143.97 198.819 143.765 199.063 143.594 199.238C143.424 199.409 143.224 199.653 143.053 199.829C142.882 199.999 142.677 200.243 142.575 200.453C142.404 200.629 142.199 200.872 142.102 201.077L142.067 201.146C141.897 201.321 141.794 201.531 141.624 201.702C141.419 201.946 141.316 202.155 141.111 202.399C140.946 202.57 140.809 202.848 140.707 203.058C140.502 203.302 140.399 203.507 140.268 203.785C140.165 203.994 139.96 204.238 139.858 204.443C139.726 204.721 139.555 204.897 139.419 205.175C139.316 205.38 139.185 205.658 139.014 205.833C138.877 206.111 138.775 206.316 138.575 206.56C138.541 206.628 138.541 206.628 138.507 206.697C138.302 207.116 138.102 207.531 137.897 207.946C131.219 221.492 124.99 235.34 117.892 248.686C132.707 221.96 165.599 222.892 192.193 221.096C226.778 218.736 261.363 216.55 295.904 213.399C353.039 208.219 417.487 232.74 451.296 280.569C451.754 281.217 452.14 281.832 452.593 282.486L502.085 355.689C503.592 357.879 504.958 360.172 506.226 362.328L526.836 320.343C525.436 318.119 524.099 315.929 522.597 313.739Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.245 325.499L196.252 9.17383L602.488 206.951L448.476 523.281L42.245 325.499Z",
    fill: "url(#paint1_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 167,
    width: 400,
    height: 179
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.229 167H529.831V345.572H130.229V167Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.714 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.714 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.714 429.859L187.769 70.2949Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.626 313.5C527.133 315.69 528.499 317.983 529.768 320.144L526.665 320.344C525.436 318.12 524.031 315.895 522.529 313.705L473.037 240.502C459.198 219.965 436.696 201.38 409.531 188.156C382.361 174.927 353.888 168.61 329.332 170.449L187.525 180.859C162.999 182.629 145.316 192.361 137.726 208.122C130.141 223.882 133.629 243.833 147.463 264.369L196.955 337.573C198.462 339.763 200.037 341.987 201.784 344.207L198.686 344.412C197.008 342.226 195.398 340.07 193.857 337.778L144.365 264.574C114.766 220.765 133.312 182.147 185.774 178.288L327.581 167.883C380.039 164.03 446.574 196.419 476.169 240.223L525.626 313.5Z",
    fill: "#2B063C"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 261,
    width: 384,
    height: 187
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.448 261.905H544.816V447.97H161.448V261.905Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 262,
    width: 384,
    height: 186
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.34 447.775L166.009 396.381C160.438 388.098 160.277 376.108 166.887 362.357C169.653 356.674 172.418 350.991 175.116 345.279C180.345 334.538 184.877 323.119 191.003 312.821C198.218 300.646 207.857 289.827 219.315 281.437C227.622 275.286 236.807 269.983 246.666 266.988C294.397 252.598 335.43 295.802 399.287 294.241C454.91 292.866 474.613 255.749 501.69 264.052C507.431 265.817 513.348 267.583 517.904 271.603C519.226 272.759 520.309 274.056 521.358 275.422C523.07 277.715 524.582 280.251 526.158 282.646C532.392 291.851 538.523 301.095 544.758 310.299L198.34 447.775Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.459 410.375L233.949 101.279L621.575 289.997L471.086 599.099L83.459 410.375Z",
    fill: "url(#paint2_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 295,
    width: 413,
    height: 233
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.672 295.622H599.761V527.891H187.672V295.622Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7139 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7139 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7139 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 296,
    width: 411,
    height: 232
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252.246 527.413L195.818 443.804C190.247 435.522 185.813 420.507 191.627 406.454C204.5 375.611 218.583 342.104 242.597 318.139C281.884 278.817 341.844 324.894 418.369 318.617C469.964 314.422 522.133 289.685 539.699 298.154C552.416 300.914 560.523 324.402 569.137 340.167C578.527 357.338 587.766 373.747 598.629 390.005L252.246 527.413Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.976 479.78L264.914 116.348L696.467 326.456L519.529 689.883L87.976 479.78Z",
    fill: "url(#paint3_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 379,
    width: 360,
    height: 159
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M248.861 379.289H607.254V537.881H248.861V379.289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 379,
    width: 358,
    height: 159
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M260.08 537.739L253.807 528.432C248.412 520.32 248.154 508.876 254.627 495.403C258.841 486.745 263.022 477.979 267.241 469.321C271.49 460.589 275.182 451.419 280.372 443.234C287.894 431.297 297.85 420.888 309.416 412.805C321.869 404.127 336.318 398.225 351.249 395.552C360.229 394.01 369.639 393.878 378.771 393.264C392.273 392.298 405.672 391.366 419.175 390.396C435.672 389.259 452.208 388.054 468.637 386.883C484.69 385.786 500.773 384.615 516.826 383.518C528.987 382.669 541.148 381.815 553.406 380.932C566.464 380.001 579.606 377.488 591.469 384.464C595.005 386.527 597.688 389.118 600.03 392.059C602.337 394.898 604.332 398.01 606.469 401.195L260.08 537.739Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.081 507.032L316.81 236.462L669.54 408.195L537.811 678.761L185.081 507.032Z",
    fill: "url(#paint4_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 388,
    width: 356,
    height: 164
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M255.104 388.03H611V551.617H255.104V388.03Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7137 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7137 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7137 429.859L187.769 70.2949Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.181 389.333C604.907 387.147 618.951 407.786 605.629 435.322L583.034 482.087C569.713 509.623 534.723 532.183 503.324 535.925C496.783 536.681 491.1 537.257 486.036 537.622C430.994 541.505 457.193 522.208 406.316 525.803C359.883 529.081 357.624 546.578 306.298 550.217C302.03 550.534 297.411 550.686 292.382 550.807C262.533 551.364 247.612 532.354 260.933 504.818L283.528 458.053C296.85 430.517 332.513 406.396 363.234 404.215L574.181 389.333Z",
    fill: "#2B063C"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 262,
    y: 395,
    width: 343,
    height: 150
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M262.597 395.522H604.756V544.124H262.597V395.522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.714 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.714 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.714 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 262,
    y: 395,
    width: 342,
    height: 149
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M273.587 540.461C268.177 537.827 264.792 533.866 263.499 528.779C262.021 523.003 263.255 515.715 267.133 507.75L289.728 460.985C295.63 448.692 306.669 436.756 320.737 427.234C334.805 417.712 350.117 411.966 363.79 411L574.737 396.113C582.176 395.625 588.737 396.591 593.586 398.952C604.746 404.381 606.912 416.834 599.493 432.249L576.898 479.014C571.03 491.067 560.157 502.833 546.196 512.145C532.401 521.286 516.953 527.305 502.563 529.042C496.363 529.793 490.685 530.369 485.651 530.661C464.261 532.164 456.413 529.969 451.632 527.642C450.315 526.998 449.101 526.325 447.784 525.51C446.325 524.627 444.832 523.818 443.101 522.974C436.794 519.906 427.872 517.276 405.931 518.847C382.234 520.506 369.156 525.881 356.629 531.013C343.551 536.383 331.127 541.476 305.913 543.256C301.645 543.578 297.094 543.764 292.338 543.847C284.962 544.027 278.504 542.856 273.587 540.461Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.613 515.593L328.108 259.886L665.321 424.059L540.826 679.766L203.613 515.593Z",
    fill: "url(#paint5_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 397,
    y: 334,
    width: 58,
    height: 17
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M397.463 334.333H454.905V350.567H397.463V334.333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.744 341.753C453.676 341.89 453.574 341.924 453.505 342.065C453.471 342.134 453.335 342.236 453.305 342.309C453.164 342.412 453.101 342.553 452.964 342.655L452.93 342.724C452.793 342.831 452.657 342.934 452.447 343.007C452.447 343.007 452.413 343.075 452.345 343.041C452.208 343.148 452.003 343.216 451.901 343.251L451.798 343.29C451.588 343.358 451.384 343.431 451.281 343.465C451.179 343.499 451.008 343.504 450.906 343.538C450.798 343.573 450.696 343.612 450.525 343.612C450.423 343.646 450.252 343.651 450.076 343.651C449.906 343.651 449.803 343.69 449.627 343.69L414.184 346.231C413.911 346.27 413.667 346.236 413.394 346.275C413.326 346.241 413.218 346.275 413.218 346.275C412.979 346.246 412.809 346.246 412.531 346.285L412.462 346.251C412.218 346.216 411.979 346.187 411.736 346.153C411.565 346.153 411.428 346.09 411.184 346.055C411.048 345.987 410.94 346.021 410.804 345.958C410.633 345.958 410.423 345.855 410.253 345.86C410.111 345.792 410.009 345.826 409.872 345.758C409.804 345.724 409.804 345.724 409.731 345.69C409.526 345.592 409.282 345.558 409.077 345.455C409.004 345.421 408.936 345.387 408.867 345.358C408.731 345.29 408.589 345.221 408.521 345.187C408.311 345.085 408.106 344.982 407.862 344.953C407.726 344.885 407.584 344.816 407.448 344.748C407.311 344.685 407.101 344.582 406.96 344.514C406.823 344.446 406.687 344.377 406.545 344.314C406.409 344.246 406.267 344.177 406.062 344.075C405.921 344.007 405.784 343.938 405.648 343.875C405.506 343.807 405.37 343.738 405.262 343.602C405.126 343.534 405.019 343.397 404.882 343.329C404.741 343.26 404.57 343.09 404.428 343.026C404.292 342.958 404.184 342.821 404.116 342.787C403.945 342.616 403.804 342.548 403.628 342.377C403.492 342.309 403.458 342.207 403.316 342.138C403.248 342.104 403.214 342.002 403.145 341.968C402.97 341.797 402.863 341.66 402.692 341.49C402.619 341.456 402.584 341.353 402.584 341.353C402.482 341.216 402.306 341.046 402.199 340.909C402.131 340.875 402.097 340.773 402.028 340.738C401.887 340.499 401.711 340.329 401.502 340.056C400.697 338.895 400.306 337.758 400.297 336.724C400.253 336.104 400.419 335.587 400.692 335.031L399.004 338.495C398.365 339.812 398.589 341.636 399.814 343.519C399.955 343.758 400.131 343.929 400.341 344.202C400.375 344.309 400.443 344.338 400.516 344.373C400.619 344.509 400.726 344.646 400.828 344.787L400.897 344.816C400.97 344.851 400.936 344.924 401.004 344.953C401.18 345.124 401.282 345.26 401.458 345.431C401.526 345.465 401.56 345.568 401.633 345.602C401.702 345.636 401.702 345.636 401.736 345.738C401.804 345.773 401.843 345.875 401.911 345.909C402.082 346.08 402.224 346.148 402.399 346.319C402.467 346.353 402.467 346.353 402.502 346.455C402.57 346.49 402.638 346.524 402.677 346.626C402.814 346.694 402.989 346.865 403.126 346.933C403.199 346.968 403.267 347.002 403.336 347.031C403.404 347.065 403.472 347.099 403.545 347.133C403.682 347.202 403.784 347.338 403.926 347.407C403.994 347.441 404.063 347.475 404.131 347.509C404.204 347.543 404.272 347.577 404.341 347.607C404.482 347.675 404.619 347.743 404.828 347.846C404.897 347.88 404.965 347.914 405.033 347.948C405.102 347.982 405.175 348.011 405.243 348.046C405.38 348.114 405.589 348.216 405.726 348.285C405.794 348.319 405.867 348.353 406.004 348.416C406.072 348.451 406.072 348.451 406.145 348.485C406.35 348.587 406.56 348.69 406.799 348.719C406.872 348.753 406.941 348.787 407.077 348.855C407.145 348.89 407.145 348.89 407.219 348.924C407.287 348.958 407.355 348.992 407.423 349.026C407.633 349.124 407.872 349.158 408.082 349.26C408.15 349.294 408.15 349.294 408.219 349.324L408.292 349.358C408.36 349.392 408.531 349.392 408.599 349.426C408.74 349.494 408.979 349.524 409.155 349.524C409.292 349.592 409.394 349.553 409.536 349.621C409.706 349.621 409.916 349.724 410.087 349.719L410.155 349.753C410.399 349.787 410.57 349.782 410.809 349.816L410.882 349.85C411.121 349.88 411.365 349.914 411.57 349.841C411.638 349.875 411.74 349.841 411.74 349.841C411.984 349.875 412.257 349.836 412.536 349.797L447.979 347.255C448.047 347.29 448.081 347.221 448.149 347.255C448.252 347.221 448.325 347.255 448.428 347.216C448.598 347.216 448.701 347.182 448.871 347.177C448.979 347.143 449.081 347.109 449.252 347.104C449.354 347.07 449.53 347.07 449.632 347.031C449.632 347.031 449.701 347.065 449.735 346.997C449.94 346.929 450.042 346.89 450.247 346.821L450.354 346.782C450.457 346.748 450.559 346.714 450.662 346.675C450.764 346.641 450.798 346.572 450.866 346.607C450.866 346.607 450.901 346.538 450.969 346.572C451.071 346.533 451.208 346.431 451.345 346.324C451.345 346.324 451.452 346.29 451.481 346.221C451.481 346.221 451.515 346.153 451.588 346.187C451.725 346.08 451.827 346.046 451.896 345.904L451.93 345.836C451.959 345.768 452.096 345.665 452.13 345.592C452.164 345.524 452.266 345.49 452.301 345.421L452.335 345.348L452.369 345.28C452.437 345.143 452.505 345.002 452.608 344.968L452.642 344.899L454.33 341.436C453.984 341.441 453.813 341.612 453.744 341.753Z",
    fill: "#2B063C"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 399,
    y: 329,
    width: 56,
    height: 18
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M399.96 329.338H454.906V346.821H399.96V329.338Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 400,
    y: 330,
    width: 55,
    height: 17
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M453.135 336.314C455.691 340.04 454.072 343.367 449.628 343.689L414.185 346.231C409.672 346.518 403.99 343.753 401.434 340.021C398.878 336.294 400.497 332.967 404.941 332.646L440.384 330.104C444.93 329.748 450.613 332.514 453.135 336.314Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.278 343.304L409.765 307.382L462.296 332.957L444.804 368.879L392.278 343.304Z",
    fill: "url(#paint6_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 404,
    y: 331,
    width: 46,
    height: 14
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M404.955 331.835H449.911V344.323H404.955V331.835Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2939L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2939L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2939L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2939Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.35 336.635C446.808 334.342 443.408 332.689 440.725 332.923L408.38 335.26C405.692 335.499 404.751 337.435 406.224 339.694C407.765 341.991 411.16 343.64 413.843 343.406L446.189 341.069C448.945 340.869 449.818 338.898 448.35 336.635Z",
    fill: "#2B063C"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 338,
    width: 30,
    height: 63
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M177.682 338.08H206.403V400.517H177.682V338.08Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.481 399.352C188.584 399.318 188.652 399.352 188.76 399.313L194.374 398.879C194.267 398.913 194.198 398.879 194.096 398.913L194.028 398.879C193.959 398.849 193.857 398.883 193.857 398.883L193.784 398.849C193.613 398.849 193.476 398.781 193.301 398.786C193.233 398.752 193.096 398.683 192.994 398.718L192.92 398.683C192.852 398.654 192.784 398.62 192.716 398.586C192.642 398.552 192.642 398.552 192.574 398.518C192.506 398.483 192.437 398.449 192.437 398.449C192.369 398.415 192.369 398.415 192.296 398.381C192.228 398.347 192.228 398.347 192.159 398.313C192.091 398.279 192.091 398.279 192.023 398.249C191.95 398.215 191.95 398.215 191.881 398.181C191.813 398.147 191.745 398.113 191.745 398.113C191.677 398.079 191.677 398.079 191.603 398.044C191.535 398.01 191.467 397.976 191.433 397.874C191.359 397.84 191.359 397.84 191.291 397.805C191.223 397.771 191.189 397.669 191.12 397.635L191.047 397.601C190.979 397.566 190.877 397.43 190.803 397.396C190.769 397.293 190.633 397.23 190.594 397.123C190.594 397.123 190.525 397.088 190.559 397.02C190.491 396.986 190.457 396.884 190.384 396.849L190.35 396.747C190.316 396.644 190.174 396.576 190.14 396.474L186.218 390.62C186.077 390.381 185.935 390.142 185.794 389.903C185.794 389.903 185.794 389.903 185.725 389.869C185.584 389.63 185.516 389.425 185.374 389.181C185.374 389.181 185.306 389.147 185.34 389.079C185.199 388.84 185.125 388.635 185.018 388.328L184.984 388.22C184.843 387.981 184.808 387.708 184.701 387.396C184.701 387.396 184.701 387.396 184.667 387.293C184.56 386.986 184.521 386.713 184.413 386.401C184.306 386.093 184.272 385.815 184.233 385.542C184.194 385.264 184.16 384.991 184.121 384.718C184.121 384.542 184.047 384.337 184.047 384.167C184.043 383.991 184.008 383.889 184.008 383.718C184.038 383.65 184.004 383.547 184.004 383.547C183.964 383.269 183.999 383.03 183.925 382.82L183.96 382.752C183.925 382.479 183.989 382.167 183.95 381.894C183.95 381.894 183.95 381.894 183.984 381.82C183.95 381.547 184.013 381.235 184.047 380.996C184.047 380.996 184.047 380.996 184.082 380.923C184.145 380.616 184.106 380.337 184.174 380.03C184.174 380.03 184.174 380.03 184.208 379.957C184.238 379.718 184.306 379.406 184.335 379.167L184.369 379.094C184.438 378.786 184.467 378.542 184.603 378.264C184.667 377.957 184.769 377.747 184.906 377.469L184.94 377.401C185.072 377.123 185.174 376.918 185.277 376.708L201.974 342.587C202.076 342.377 202.208 342.099 202.31 341.894L202.345 341.826C202.447 341.616 202.618 341.441 202.686 341.304L202.715 341.236C202.886 341.06 202.954 340.924 203.125 340.748L203.159 340.68C203.296 340.572 203.432 340.47 203.603 340.294C203.603 340.294 203.603 340.294 203.637 340.226C203.774 340.119 203.945 339.948 204.149 339.875C204.149 339.875 204.184 339.807 204.252 339.841C204.388 339.733 204.496 339.699 204.632 339.597C204.667 339.524 204.735 339.558 204.769 339.489C204.871 339.455 204.974 339.416 205.076 339.382L205.179 339.348C205.349 339.348 205.491 339.241 205.662 339.241L200.047 339.675C199.876 339.68 199.701 339.68 199.564 339.787C199.496 339.753 199.462 339.821 199.462 339.821C199.359 339.855 199.257 339.889 199.154 339.929C199.12 339.997 199.052 339.963 199.018 340.031C198.915 340.07 198.779 340.172 198.637 340.275C198.637 340.275 198.608 340.348 198.535 340.314C198.398 340.416 198.262 340.524 198.125 340.626C198.125 340.626 198.125 340.626 198.091 340.694C197.989 340.733 197.92 340.87 197.818 340.904C197.784 340.977 197.784 340.977 197.681 341.011L197.613 341.148C197.579 341.221 197.442 341.324 197.379 341.46C197.345 341.533 197.345 341.533 197.311 341.602L197.276 341.67C197.242 341.738 197.242 341.738 197.208 341.807C197.174 341.88 197.106 342.016 197.003 342.05C196.969 342.124 196.935 342.192 196.935 342.192L196.901 342.26L196.872 342.328C196.837 342.397 196.769 342.538 196.735 342.607C196.701 342.675 196.633 342.816 196.598 342.885L179.901 377.006C179.867 377.074 179.799 377.216 179.765 377.284C179.73 377.352 179.667 377.489 179.633 377.562C179.599 377.63 179.599 377.63 179.565 377.699L179.53 377.767C179.496 377.835 179.496 377.835 179.462 377.908C179.428 377.977 179.36 378.113 179.326 378.181C179.262 378.323 179.228 378.391 179.228 378.562C179.194 378.63 179.126 378.772 179.165 378.874C179.096 379.011 179.13 379.118 179.062 379.255C179.028 379.323 179.028 379.323 178.994 379.391L178.96 379.464C178.93 379.533 178.93 379.533 178.896 379.601C178.828 379.738 178.862 379.84 178.794 379.981C178.76 380.05 178.799 380.152 178.73 380.294C178.73 380.294 178.73 380.294 178.696 380.362C178.696 380.362 178.696 380.362 178.662 380.43C178.594 380.567 178.628 380.674 178.633 380.845C178.633 381.016 178.599 381.084 178.604 381.259L178.569 381.328C178.569 381.328 178.569 381.328 178.535 381.396C178.501 381.464 178.535 381.567 178.501 381.64C178.54 381.742 178.472 381.879 178.506 381.981C178.472 382.055 178.506 382.157 178.477 382.225C178.477 382.225 178.477 382.225 178.443 382.294C178.443 382.294 178.443 382.294 178.408 382.362C178.443 382.464 178.374 382.606 178.408 382.708C178.413 382.879 178.448 382.981 178.379 383.123C178.379 383.123 178.379 383.123 178.345 383.191L178.311 383.259C178.35 383.362 178.282 383.503 178.316 383.606C178.321 383.776 178.355 383.879 178.355 384.054C178.321 384.123 178.36 384.225 178.36 384.225C178.36 384.225 178.326 384.294 178.394 384.328C178.428 384.43 178.433 384.601 178.399 384.674C178.399 384.845 178.399 385.015 178.472 385.225C178.472 385.225 178.438 385.293 178.506 385.328C178.545 385.601 178.618 385.806 178.584 386.05C178.584 386.22 178.657 386.425 178.691 386.532C178.73 386.635 178.73 386.806 178.765 386.908C178.804 387.011 178.804 387.186 178.838 387.289C178.877 387.391 178.877 387.562 178.979 387.698C178.979 387.698 178.979 387.698 179.018 387.801C179.018 387.801 179.018 387.801 179.052 387.903C179.087 388.011 179.126 388.113 179.16 388.215C179.194 388.318 179.267 388.523 179.301 388.625L179.335 388.728L179.374 388.83C179.408 388.937 179.408 388.937 179.443 389.04C179.482 389.142 179.584 389.279 179.584 389.45C179.657 389.484 179.623 389.552 179.691 389.586C179.691 389.586 179.76 389.62 179.726 389.689L179.76 389.791C179.799 389.898 179.901 390.035 179.94 390.137C179.974 390.24 180.043 390.274 180.077 390.376C180.077 390.376 180.077 390.376 180.15 390.41C180.15 390.41 180.15 390.41 180.218 390.445C180.252 390.547 180.36 390.684 180.394 390.786C180.428 390.889 180.535 391.025 180.604 391.059C180.604 391.059 180.672 391.093 180.638 391.162L184.56 397.015C184.599 397.118 184.667 397.152 184.701 397.254C184.701 397.254 184.769 397.288 184.74 397.357L184.774 397.459C184.774 397.459 184.843 397.493 184.808 397.566C184.877 397.596 184.843 397.669 184.916 397.703C184.916 397.703 184.984 397.732 184.95 397.805C184.95 397.805 184.95 397.805 185.018 397.84C185.052 397.942 185.125 397.976 185.228 398.113C185.296 398.147 185.335 398.249 185.472 398.318L185.54 398.347C185.608 398.381 185.608 398.381 185.647 398.488L185.716 398.518C185.784 398.552 185.784 398.552 185.852 398.586L185.925 398.62L185.994 398.654C186.062 398.688 186.062 398.688 186.13 398.723L186.199 398.757C186.272 398.791 186.272 398.791 186.34 398.825C186.408 398.859 186.408 398.859 186.477 398.893C186.477 398.893 186.477 398.893 186.545 398.922C186.618 398.957 186.618 398.957 186.686 398.991C186.755 399.025 186.755 399.025 186.823 399.059C186.823 399.059 186.823 399.059 186.896 399.093L186.964 399.127C187.033 399.162 187.101 399.196 187.101 399.196C187.101 399.196 187.101 399.196 187.169 399.23L187.242 399.264C187.311 399.298 187.379 399.327 187.447 399.362L187.516 399.396C187.516 399.396 187.516 399.396 187.589 399.43C187.657 399.464 187.794 399.532 187.896 399.498C188.038 399.566 188.208 399.562 188.379 399.562C188.379 399.562 188.379 399.562 188.452 399.596C188.52 399.63 188.623 399.591 188.623 399.591C188.413 399.318 188.481 399.352 188.481 399.352Z",
    fill: "#401952"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 335,
    width: 39,
    height: 70
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M175.184 335.582H213.896V404.264H175.184V335.582Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.714 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.714 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.714 429.858L187.769 70.2944Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.793 345.192C213.33 350.431 213.94 359.211 211.174 364.894L194.477 399.015C191.711 404.693 186.613 404.956 183.072 399.717L179.15 393.864C175.614 388.63 175.004 379.849 177.77 374.167L194.467 340.045C197.198 334.431 202.33 334.104 205.867 339.338L209.793 345.192ZM192.584 396.205L209.286 362.084C211.208 358.138 210.793 351.938 208.31 348.24L204.384 342.387C201.896 338.694 198.281 338.904 196.325 342.918L179.628 377.045C177.701 380.991 178.116 387.191 180.599 390.888L184.526 396.742C187.013 400.434 190.628 400.225 192.584 396.205Z",
    fill: "#562C69"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 334,
    width: 31,
    height: 71
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M188.921 334.333H218.891V404.264H188.921V334.333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7142 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7142 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7142 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 335,
    width: 30,
    height: 69
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M216.959 364.108L216.993 364.04C217.027 363.967 217.061 363.898 217.061 363.898C217.091 363.83 217.125 363.762 217.159 363.693C217.193 363.62 217.193 363.62 217.227 363.552C217.261 363.484 217.296 363.415 217.296 363.415C217.33 363.347 217.33 363.347 217.364 363.274C217.398 363.206 217.432 363.137 217.496 363.001C217.53 362.928 217.53 362.928 217.564 362.859C217.564 362.859 217.564 362.859 217.598 362.791C217.666 362.654 217.666 362.479 217.73 362.342L217.764 362.274C217.832 362.133 217.832 361.962 217.866 361.893L217.9 361.825C217.935 361.752 217.964 361.684 217.93 361.581C217.964 361.513 217.998 361.445 217.964 361.342C217.998 361.269 217.998 361.269 218.032 361.201C218.061 361.133 218.096 361.064 218.061 360.962C218.096 360.889 218.096 360.889 218.061 360.786C218.096 360.718 218.13 360.65 218.091 360.547C218.125 360.479 218.159 360.406 218.125 360.303L218.159 360.235C218.193 360.167 218.154 360.064 218.222 359.923C218.257 359.854 218.291 359.786 218.222 359.752C218.222 359.752 218.222 359.752 218.257 359.684C218.252 359.508 218.32 359.372 218.354 359.128C218.354 359.128 218.354 359.128 218.388 359.059C218.383 358.889 218.452 358.752 218.452 358.576L218.486 358.508C218.515 358.44 218.447 358.406 218.481 358.337C218.515 358.264 218.481 358.162 218.515 358.094C218.549 358.025 218.476 357.991 218.51 357.923C218.544 357.855 218.51 357.752 218.51 357.752C218.544 357.679 218.544 357.679 218.51 357.576C218.544 357.508 218.505 357.406 218.505 357.235C218.539 357.162 218.471 357.128 218.5 357.059C218.5 357.059 218.5 357.059 218.535 356.991C218.535 356.82 218.535 356.645 218.53 356.474C218.564 356.406 218.496 356.372 218.53 356.303C218.525 356.128 218.559 356.059 218.559 355.889C218.559 355.889 218.559 355.889 218.593 355.82C218.559 355.718 218.622 355.577 218.588 355.474C218.554 355.372 218.588 355.303 218.554 355.201C218.554 355.201 218.554 355.201 218.583 355.128C218.549 354.855 218.544 354.508 218.505 354.235L218.539 354.167C218.539 354.167 218.574 354.094 218.505 354.064C218.466 353.616 218.393 353.235 218.422 352.82C218.422 352.82 218.422 352.82 218.457 352.752L218.422 352.65C218.418 352.303 218.31 351.996 218.271 351.723C218.203 351.513 218.164 351.24 218.164 351.069C218.159 350.894 218.057 350.757 218.057 350.586L218.018 350.484C217.949 350.279 217.944 350.103 217.876 349.899C217.837 349.796 217.837 349.796 217.803 349.694C217.769 349.591 217.735 349.484 217.73 349.313C217.73 349.313 217.73 349.313 217.696 349.211C217.661 349.108 217.691 349.04 217.622 349.006C217.588 348.903 217.554 348.801 217.588 348.728L217.549 348.625C217.515 348.523 217.481 348.421 217.481 348.421C217.442 348.318 217.442 348.318 217.408 348.216L217.374 348.113C217.339 348.011 217.3 347.904 217.232 347.869C217.198 347.767 217.198 347.767 217.159 347.664L217.125 347.562C217.091 347.46 217.057 347.357 216.983 347.323C216.915 347.289 216.949 347.221 216.881 347.186C216.813 347.152 216.847 347.084 216.774 347.05C216.739 346.947 216.671 346.913 216.637 346.811L216.598 346.708C216.564 346.601 216.564 346.601 216.53 346.499C216.491 346.396 216.422 346.362 216.457 346.294L216.422 346.191C216.388 346.089 216.315 346.055 216.281 345.952C216.213 345.918 216.247 345.85 216.179 345.816C216.179 345.816 216.179 345.816 216.105 345.782C216.003 345.645 215.896 345.508 215.896 345.333C215.788 345.196 215.754 345.094 215.652 344.957C215.652 344.957 215.579 344.923 215.613 344.855L211.691 339.001C211.657 338.899 211.549 338.762 211.481 338.728C211.413 338.694 211.447 338.626 211.379 338.591C211.305 338.557 211.34 338.489 211.271 338.455C211.203 338.421 211.237 338.352 211.169 338.318C211.096 338.284 211.062 338.182 210.993 338.148C210.925 338.113 210.959 338.045 210.886 338.011L210.818 337.977C210.715 337.84 210.642 337.806 210.54 337.67C210.432 337.533 210.364 337.499 210.262 337.362C210.262 337.362 210.262 337.362 210.188 337.328C210.12 337.294 210.12 337.294 210.086 337.192C210.018 337.157 209.979 337.055 209.91 337.021L209.842 336.987C209.774 336.957 209.705 336.923 209.74 336.85C209.666 336.821 209.666 336.821 209.598 336.787C209.53 336.753 209.53 336.753 209.462 336.718C209.393 336.684 209.32 336.65 209.354 336.582L209.286 336.548C209.218 336.513 209.218 336.513 209.149 336.479C209.076 336.445 209.008 336.411 208.94 336.377L208.871 336.343C208.803 336.309 208.803 336.309 208.73 336.274C208.662 336.245 208.593 336.211 208.525 336.177L208.457 336.143C208.384 336.109 208.384 336.109 208.315 336.074C208.247 336.04 208.179 336.006 208.11 335.972L208.037 335.938L207.969 335.904C207.901 335.87 207.759 335.806 207.691 335.772L207.554 335.704C207.413 335.635 207.276 335.567 207.106 335.572C207.106 335.572 207.106 335.572 207.032 335.538L206.964 335.504C206.896 335.47 206.793 335.504 206.657 335.435C206.584 335.401 206.584 335.401 206.481 335.44C206.413 335.406 206.345 335.372 206.31 335.44C206.31 335.44 206.31 335.44 206.242 335.406C206.169 335.372 206.067 335.406 205.998 335.377C205.93 335.343 205.93 335.343 205.828 335.377C205.652 335.377 205.549 335.416 205.413 335.348L199.798 335.782C199.969 335.782 200.072 335.748 200.213 335.816C200.281 335.85 200.281 335.85 200.384 335.811C200.452 335.845 200.559 335.811 200.628 335.845C200.696 335.879 200.798 335.84 200.867 335.874C200.935 335.909 200.935 335.909 201.042 335.874C201.111 335.909 201.213 335.874 201.35 335.938L201.423 335.972C201.423 335.972 201.423 335.972 201.491 336.006C201.628 336.074 201.803 336.074 201.94 336.143C202.008 336.177 202.008 336.177 202.076 336.206C202.15 336.24 202.286 336.309 202.354 336.343C202.423 336.377 202.496 336.411 202.496 336.411C202.564 336.445 202.632 336.479 202.701 336.513C202.769 336.548 202.842 336.582 202.91 336.611C202.979 336.645 203.047 336.679 203.115 336.713C203.189 336.748 203.257 336.782 203.325 336.816C203.393 336.85 203.462 336.884 203.535 336.918C203.603 336.953 203.671 336.987 203.706 337.089C203.779 337.123 203.847 337.157 203.813 337.226C203.881 337.26 203.915 337.362 204.057 337.431C204.125 337.46 204.193 337.494 204.159 337.567C204.232 337.601 204.335 337.738 204.403 337.767C204.471 337.801 204.471 337.801 204.51 337.909C204.613 338.045 204.754 338.109 204.857 338.245C204.964 338.382 205.067 338.523 205.174 338.66C205.242 338.689 205.208 338.762 205.276 338.796C205.31 338.899 205.452 338.967 205.486 339.07C205.554 339.104 205.52 339.172 205.593 339.206C205.696 339.343 205.803 339.479 205.906 339.616L209.827 345.469C209.935 345.606 210.037 345.743 210.11 345.947C210.218 346.084 210.286 346.289 210.393 346.425C210.462 346.46 210.427 346.528 210.496 346.562C210.53 346.665 210.637 346.801 210.671 346.908C210.71 347.011 210.779 347.045 210.744 347.113C210.779 347.216 210.813 347.318 210.92 347.455C210.954 347.557 211.023 347.591 211.062 347.694C211.096 347.796 211.13 347.899 211.169 348.006C211.203 348.108 211.237 348.211 211.305 348.245C211.344 348.347 211.379 348.45 211.413 348.552C211.452 348.655 211.486 348.757 211.554 348.791C211.588 348.894 211.627 348.996 211.662 349.103C211.696 349.206 211.735 349.308 211.735 349.308C211.769 349.411 211.803 349.513 211.837 349.616C211.876 349.718 211.842 349.791 211.91 349.821C211.944 349.928 212.018 350.133 212.052 350.235C212.086 350.338 212.086 350.338 212.125 350.44C212.193 350.645 212.266 350.855 212.266 351.025L212.305 351.128C212.305 351.299 212.379 351.508 212.413 351.611C212.481 351.816 212.52 352.089 212.52 352.264C212.627 352.572 212.632 352.918 212.671 353.191C212.637 353.26 212.705 353.294 212.671 353.367C212.744 353.742 212.783 354.191 212.754 354.606C212.72 354.674 212.788 354.708 212.754 354.777C212.793 355.055 212.798 355.396 212.832 355.674C212.871 355.777 212.837 355.845 212.837 356.016C212.876 356.118 212.808 356.259 212.842 356.362C212.842 356.533 212.847 356.708 212.881 356.811C212.847 356.879 212.915 356.913 212.881 356.981C212.886 357.152 212.852 357.396 212.857 357.567C212.822 357.635 212.891 357.669 212.857 357.737C212.857 357.913 212.862 358.084 212.827 358.152C212.793 358.225 212.827 358.328 212.827 358.328C212.832 358.498 212.798 358.567 212.798 358.742C212.764 358.811 212.832 358.845 212.798 358.913C212.803 359.084 212.769 359.328 212.701 359.464C212.701 359.464 212.701 359.464 212.671 359.533C212.671 359.708 212.637 359.947 212.574 360.089C212.54 360.157 212.505 360.225 212.574 360.259C212.505 360.396 212.54 360.498 212.476 360.64C212.442 360.708 212.476 360.811 212.442 360.879C212.374 361.02 212.408 361.123 212.344 361.259C212.31 361.328 212.276 361.401 212.31 361.503C212.242 361.64 212.281 361.742 212.213 361.884C212.179 361.952 212.144 362.02 212.179 362.123C212.11 362.264 212.115 362.435 212.047 362.572L212.013 362.645C211.944 362.781 211.915 363.025 211.847 363.162C211.813 363.23 211.813 363.23 211.779 363.298C211.71 363.44 211.676 363.508 211.681 363.679C211.647 363.747 211.613 363.82 211.613 363.82C211.544 363.957 211.51 364.025 211.442 364.167C211.408 364.235 211.374 364.303 211.374 364.303C211.31 364.445 211.208 364.65 211.14 364.791L194.442 398.912C194.374 399.049 194.272 399.259 194.203 399.395C194.169 399.463 194.169 399.463 194.14 399.532C194.072 399.673 194.037 399.742 193.969 399.883C193.935 399.951 193.901 400.02 193.867 400.088C193.833 400.156 193.764 400.298 193.735 400.366C193.701 400.434 193.667 400.502 193.633 400.576C193.598 400.644 193.564 400.712 193.462 400.746C193.428 400.815 193.394 400.888 193.291 400.922C193.257 400.99 193.223 401.059 193.12 401.098C193.086 401.166 192.984 401.2 192.916 401.337C192.881 401.41 192.779 401.444 192.745 401.512C192.711 401.581 192.574 401.688 192.54 401.756C192.506 401.824 192.438 401.79 192.403 401.863C192.267 401.966 192.13 402.073 191.959 402.244C191.823 402.351 191.72 402.385 191.652 402.522C191.516 402.629 191.413 402.663 191.311 402.698C191.174 402.805 190.969 402.878 190.833 402.98L190.725 403.015C190.589 403.122 190.418 403.122 190.281 403.229C190.077 403.298 189.974 403.337 189.799 403.337L189.696 403.371C189.525 403.376 189.321 403.444 189.145 403.444L194.759 403.01C194.935 403.005 195.106 403.005 195.311 402.932L195.413 402.898C195.589 402.898 195.794 402.824 195.896 402.79C196.101 402.717 196.203 402.683 196.34 402.581L196.447 402.541C196.584 402.439 196.789 402.366 196.925 402.263C197.028 402.224 197.164 402.122 197.267 402.088C197.369 402.049 197.506 401.946 197.54 401.878C197.676 401.771 197.813 401.668 197.984 401.493C197.984 401.493 197.984 401.493 198.018 401.424C198.052 401.356 198.052 401.356 198.154 401.317C198.189 401.249 198.325 401.146 198.359 401.073L198.393 401.005C198.428 400.937 198.428 400.937 198.462 400.868C198.496 400.8 198.598 400.761 198.667 400.624L198.701 400.556C198.735 400.488 198.735 400.488 198.764 400.415C198.798 400.346 198.833 400.278 198.935 400.244C198.969 400.171 198.969 400.171 199.003 400.103C199.037 400.034 199.037 400.034 199.072 399.966C199.106 399.898 199.14 399.824 199.174 399.756L199.208 399.688C199.242 399.62 199.276 399.551 199.276 399.551C199.306 399.478 199.34 399.41 199.374 399.342L199.408 399.273C199.442 399.205 199.476 399.132 199.545 398.995C199.579 398.927 199.579 398.927 199.613 398.859C199.676 398.717 199.745 398.581 199.813 398.439L216.51 364.318C216.822 364.386 216.891 364.245 216.959 364.108Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.341 390.396L194.794 323.738L245.427 348.391L212.979 415.049L162.341 390.396Z",
    fill: "url(#paint7_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 241,
    width: 72,
    height: 103
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M132.726 241.925H203.905V343.075H132.726V241.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask66_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7141 429.858L187.769 70.2944Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.463 264.369C142.702 257.252 139.107 250.189 136.829 243.423C135.692 243.296 134.517 243.067 133.409 242.872C135.726 249.91 139.39 257.179 144.434 264.608L193.925 337.811C195.433 340.001 197.106 341.67 199.867 342.157C200.798 342.357 202.715 341.236 203.057 340.884C202.989 340.85 202.954 340.748 202.954 340.748C199.433 340.406 198.598 339.831 197.028 337.606L147.463 264.369Z",
    fill: "#2B063C"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 351,
    width: 26,
    height: 76
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M206.403 351.816H231.378V426.741H206.403V351.816Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7139 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7139 429.858L187.769 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask72_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2944L669.433 304.797L494.378 664.361L12.7139 429.858L187.769 70.2944Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.242 425.624C209.179 426.57 211.544 425.063 212.456 423.366C214.281 420.141 215.256 417.615 216.671 414.707C218.627 410.688 220.583 406.668 222.505 402.717C224.227 399.186 225.949 395.654 227.7 392.049C228.378 390.664 229.256 389.205 229.827 387.683C229.993 387.166 230.124 386.718 230.188 386.235C230.505 383.644 228.934 381.766 227.603 379.747C226.1 377.557 224.593 375.367 223.188 373.142C221.403 370.474 219.617 367.801 217.832 365.133C216.291 362.84 214.681 360.513 213.139 358.221C212.681 357.572 212.261 356.85 211.808 356.201C211.315 355.445 210.725 354.904 210.364 353.352C210.325 353.25 210.183 352.669 210.115 352.635C209.452 352.055 207.515 354.796 206.52 354.913L207.242 425.624Z",
    fill: "#2B063C"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 351,
    width: 42,
    height: 76
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M186.423 351.816H227.632V426.741H186.423V351.816Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask75_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 70.2944L669.433 304.797L494.378 664.361L12.7144 429.858L187.77 70.2944Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 352,
    width: 42,
    height: 74
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M226.671 382.723C227.481 384.23 227.817 386.532 227.071 388.059L209.262 424.468C208.52 425.99 207.106 426.073 206.159 424.673L187.423 396.952C186.477 395.547 186.277 393.137 187.023 391.615C187.023 391.615 200.111 361.562 204.871 355.65C206.13 354.123 209.998 351.635 210.11 352.46C210.115 352.806 210.115 352.806 210.013 353.016C207.754 357.825 222.349 375.045 226.671 382.723Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.98 411.81L194.238 335.289L257.115 365.898L219.857 442.424L156.98 411.81Z",
    fill: "url(#paint8_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 205,
    width: 95,
    height: 181
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M109 205.711H203.905V385.532H109V205.711Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7137 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7137 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 70,
    width: 658,
    height: 595
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M187.769 70.2949L669.433 304.798L494.378 664.362L12.7137 429.859L187.769 70.2949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 206,
    width: 94,
    height: 179
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M193.857 337.778L144.365 264.574C129.477 242.501 126.775 221.814 134.468 206.19L113.853 248.174C106.161 263.799 108.902 284.588 123.751 306.559L173.242 379.762C174.398 381.44 175.618 382.635 177.115 384.133C177.989 384.986 182.169 386.079 183.959 382.411L202.988 340.851C197.905 342.665 195.398 340.07 193.857 337.778Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3624 351.612L124.717 168.083L273.787 240.658L184.438 424.191L35.3624 351.612Z",
    fill: "url(#paint9_linear_49_1590)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 601,
    y: 23,
    width: 171,
    height: 170
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M601.484 23H771.068V192.589H601.484V23Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask84_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 601,
    y: 23,
    width: 171,
    height: 170
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M686.276 23C639.448 23 601.484 60.9635 601.484 107.797C601.484 154.625 639.448 192.589 686.276 192.589C733.104 192.589 771.068 154.625 771.068 107.797C771.068 60.9635 733.104 23 686.276 23Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.484 23V192.589H771.068V23H601.484Z",
    fill: "url(#paint10_linear_49_1590)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 517,
    width: 118,
    height: 118
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16 517.031H133.635V634.667H16V517.031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_49_1590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask86_49_1590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 517,
    width: 118,
    height: 118
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8177 517.031C42.3333 517.031 16 543.365 16 575.849C16 608.333 42.3333 634.667 74.8177 634.667C107.302 634.667 133.635 608.333 133.635 575.849C133.635 543.365 107.302 517.031 74.8177 517.031Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_49_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 517.031V634.667H133.635V517.031H16Z",
    fill: "url(#paint11_linear_49_1590)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_49_1590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.00218364 -0.000485253) scale(1017.65 1017.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0053C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#0152C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#0152C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#0151C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#0251C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#0251C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#0251C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#0350C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#0350C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#0350C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#044FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#044FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#044FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#054EBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#054EBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#054EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#064DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#064DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#064DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#074DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#074CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#074CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#084CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#084BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#084BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#094BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#094AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#094AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#0A4AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#0A49B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#0A49B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0B49B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#0B49B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#0B48B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#0B48B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#0C48B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#0C47B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#0C47B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#0D47B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#0D46B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#0D46B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#0E46B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#0E45B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#0E45B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#0F45B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#0F45B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#0F44B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#1044B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#1044B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#1043B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#1143AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#1143AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#1142AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#1242AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#1242AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#1241AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#1341AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#1341AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#1341AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#1440AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#1440AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#1440AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#153FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#153FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#153FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#163EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#173DA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#173DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#183CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#193BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#193BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#1A3AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#1B3AA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#1B39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#1C38A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#1C38A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#1D379F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#1E379E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#1E369D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#1F359C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#20359B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#20349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#21339A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#223399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#223298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#233297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#243196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#243095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#253095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#262F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#262F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#272E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#272D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#282D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#292C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#292B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#2A2B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#2A2B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#2B2A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#2B2A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#2B2A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#2C298C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#2C298B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#2C298B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#2D298A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#2D288A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#2D288A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2D2889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#2E2789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#2E2788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#2E2788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#2F2688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#2F2687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#2F2687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#302586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#302586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#302585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#312585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#312485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#312484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#322484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#322383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#322383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#332382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#332282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#332282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#342281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#342181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#342180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#35207F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#36207E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#361F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#371F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#381E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#381D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#391D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#3A1C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#3A1B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#3B1B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#3C1A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#3C1A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#3D1975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#3E1874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#3E1873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#3F1773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#3F1772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#3F1772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#401671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#401671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#401670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#411570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#411570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#41156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#42156F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#42146E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#42146E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#43146E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#43136D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#43136D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#43136C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#44126C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#45126B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#45116A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#461069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#471068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#470F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#480F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#490E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#490D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#490D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#4A0D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#4A0D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#4A0C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#4B0C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#4B0C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4B0B62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#4C0B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#4C0A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#4D0A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#4E095F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#4E095E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4F085E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#4F085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4F085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#50075C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#50075B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#51065B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#51065A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#52055A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#520559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#530458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#530458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_49_1590",
    x1: 533.041,
    y1: 349.589,
    x2: 126.807,
    y2: 151.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B0388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4B0388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#4B0388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#4B0388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#4B0388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#4C0488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#4C0488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#4D0589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#4E0689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#4F0889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#510989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#520A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#530B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#540C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#550D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#560E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#58108B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#59118C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#5B138C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#5D158D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#5E168D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#60188D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#611A8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#631B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#651D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#661E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#682090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#6A2290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#6B2390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#6D2591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#6E2691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#702892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#722A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#742C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#762E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#783094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#7A3294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#7C3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#7E3695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#803896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#823A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#843C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#863E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#884098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#8A4298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#8C4499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#8E4699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#91489A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#934A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#954C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#974E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#99509C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#9B529D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#9D549D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#9F569E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#A1589E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#A35A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#A65D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#A85FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#AA61A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#AC63A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#AF66A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#B168A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#B067A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#AF66A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#AD64A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#AC639F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#AA629F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#A9609E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#A75F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#A65E9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#A55C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#A35B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#A25A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#A0589B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#9F579A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#9D569A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#9C5499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#9B5399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#995298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#985097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#964F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#954D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#944C96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#924B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#914995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#8F4894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#8E4793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#8C4593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#8B4492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#8A4392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#884191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#874091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#853F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#843D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#823C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#813B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#80398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#7E388D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#7D368D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#7B358C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#7A348B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#79328B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#77318A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#76308A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#742E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#732D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#712C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#702A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#6F2987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#6D2886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#6C2686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#6A2585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#692485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#682284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#662183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#652083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#631E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#621D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#601B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#5F1A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#5E1980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#5C177F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#5B167F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#59157E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#58137E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#56127D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#55117D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#540F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#520E7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#510D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#4F0B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#4E0A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4D0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#4B0779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#4A0678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4A0678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A0678"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_49_1590",
    x1: 78.9645,
    y1: 375.218,
    x2: 623.566,
    y2: 305.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D0245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2D0245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2D0245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2D0245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#2D0245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#2E0246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2F0346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#300347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#300347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#310348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#320348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#330349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#330449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#340449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#35044A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#36044A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#36044B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#37054B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#38054C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#38054C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#39054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#3A054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3B064D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#3B064E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#3C064E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#3D064F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3E064F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#3E0650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#3F0750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#400751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#400751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#410752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#420752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#430852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#430853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#440853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#450854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#460854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#460855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#470955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#480956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#490956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#490956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#4A0957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#4B0A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#4B0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#4C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#4D0A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#4E0A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#4E0A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#4F0B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#500B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#510B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#510B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#520B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#530C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#530C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#540C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#550C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#560C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#560D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#570D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#580D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#590D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#590D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#5A0D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#5B0E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#5C0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#5C0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#5D0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#5E0E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#5E0F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#5F0F64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#600F64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#610F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#610F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#620F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#631066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#641066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#641067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#651067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#661068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#671168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#671169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#681169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#69116A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#69116A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#6A126A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#6B126B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#6C126B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#6C126C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#6D126C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#6E126D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#6F136D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#6F136E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#70136E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#71136F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#71136F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#72146F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#731470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#741470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#741471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#751471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#761472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#771572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#771573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#781573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#791573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#7A1574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#7A1674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#7B1675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#7C1675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#7C1676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#7D1676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#7E1677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#7F1777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#7F1777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#801778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#811778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#821779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#821879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#83187A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#84187A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#84187B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#85187B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#86197B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#87197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#87197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#88197D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#89197D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#8A197E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#8A1A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#8B1A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#8C1A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#8D1A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#8D1A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#8E1B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#8F1B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#8F1B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#901B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#911B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#921B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#921C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#931C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#941C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#951C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#951C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#961D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#971D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#971D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#981D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#991D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#9A1E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#9A1E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#9B1E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#9C1E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#9D1E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#9D1E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#9E1F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#9F1F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#A01F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#A01F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#A11F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#A2208C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#A2208D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#A3208D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#A4208E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#A5208E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#A5208F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#A6218F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#A72190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#A82190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#A82190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#A92191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#AA2291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#AA2292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#AB2292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#AB2292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#AB2292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_49_1590",
    x1: 122.87,
    y1: 536.433,
    x2: 632.468,
    y2: 222.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#967494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#967494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#967494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#977595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#977695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#987696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#987796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#997897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#997997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#9A7998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#9A7A98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#9B7B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#9C7B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#9C7C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#9D7D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#9D7E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#9E7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#9E7F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#9F809D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#9F809D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#A0819E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#A0829E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#A1839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#A2839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#A284A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#A385A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#A385A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#A486A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#A487A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#A588A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#A588A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#A689A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#A68AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#A78AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#A78BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#A88CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#A98DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#A98DA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#AA8EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#AA8FA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#AB8FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#AB90A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#AC91AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#AC92AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#AD92AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#AD93AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#AE94AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#AE94AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#AF95AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#B096AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#B097AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#B197AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#B198AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#B299B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#B299B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#B39AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B39BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#B49CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#B49CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#B59DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B69EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#B79FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#B8A0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#B8A1B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#B9A2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#BAA3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#BBA4B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#BCA5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#BDA6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#BEA7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#BEA7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#BFA8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C0A9BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#C1AABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C2ABC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#C3ACC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C4ADC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#C4AEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C5AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#C6B0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C7B1C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#C8B2C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#C9B3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#CAB4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#CAB5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#CBB6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#CCB7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#CDB8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#CEB9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#CFBACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#D0BBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#D0BBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D1BCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#D2BDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D3BED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#D4BFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D5C0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#D6C1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#D6C2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#D7C3D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D8C4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#D9C5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#DAC6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#DBC7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#DCC8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#DCC9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#DDCADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#DECBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#DFCCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#E0CDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E1CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#E2CFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E2D0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#E3D0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#E4D1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#E5D2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#E6D3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#E7D4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#E8D5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#E8D6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9D7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#EAD8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#EBD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#ECDAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#ECDAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#EDDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#EEDCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#EEDDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EFDDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#F0DEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#F1DFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#F1E0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F2E1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#F3E1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#F3E2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#F4E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F5E4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#F5E4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#F6E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#F7E6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F8E7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#F8E8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#F9E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#FAE9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FAEAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#FBEBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#FCEBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#FDECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#FEEEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FFEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_49_1590",
    x1: 667.114,
    y1: 468.822,
    x2: 187.379,
    y2: 449.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8831AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#8831AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#8831AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#8731AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#8730AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#862FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#852EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#842EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#832DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#822CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#812CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#812BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#802AA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#7F2AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7E29A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251612,
    stopColor: "#7D29A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#7D28A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#7D28A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#7C28A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7B27A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#7A26A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#7926A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#78259F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#78259E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#77249D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#76239C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#75239B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#74229B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#74229A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#732199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#722098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#712097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#701F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#701F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#6F1E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#6E1E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#6D1D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#6C1C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#6B1C91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#6B1B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#6A1B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#691A8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#68198E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#67198D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#67188C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#66188B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#65178A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#641789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#631688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#631588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#621587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#611486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#611485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#601385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#5F1384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#5F1384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#5E1283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#5E1282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#5D1182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#5C1181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#5C1080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#5B1080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#5A0F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#5A0F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#590E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#590E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#580E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#570D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#570D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#560C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#560C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#550B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#540B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#540A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#530A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#530977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#520976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#510975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#510875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748388,
    stopColor: "#500874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#500774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#500774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4F0773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4E0672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4D0671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4D0571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4C0570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4B046F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4B046F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4A036E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#49036E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#49026D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#48026C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#47016C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47016B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_49_1590",
    x1: 494.074,
    y1: 334.086,
    x2: 373.058,
    y2: 604.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0412939,
    stopColor: "#270083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#270083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#270083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#270183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#260183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#250283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#250382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#240482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#230582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#230582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#220682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#220782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#210881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#210881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#200981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#200A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#1F0A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#1F0B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#1E0C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#1D0D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#1D0D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#1C0E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#1C0F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#1B1080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#1B1080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#1A1180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#1A1280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#191280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#181380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#181480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#17157F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#17157F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#16167F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#16177F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#15177F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#15187F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#14197F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#131A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#131A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#121B7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#121C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#111D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#111D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#101E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#101E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0F1F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#0F207E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0E217E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#0D227D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0C237D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#0C247D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0B247D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#0A257D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#09267D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#09277D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#08287D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#07297C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#062A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#062B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#052C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#042D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#042D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#032E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#032F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#02307B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#01317B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#01327B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00337B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#00347C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00347C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#00357D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#00367E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#00377F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#003880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#003981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#003A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#003B83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#003C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#003D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#003E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#003F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#004188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#004289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00438A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#00448B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#00468D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#00478E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#00488F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#004990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#004A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#004B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#004C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#004D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#004E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#004F96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#005097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#005198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#005299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00539A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#00549B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00559C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#00569D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00579E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#00589F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#0059A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#005BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#005CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#005DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#005EA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#005FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#0060A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#0061A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#0062A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#0063AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#0064AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#0065AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#0066AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#0067AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#0069AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#006AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#006BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#006CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#006DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#006EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#006FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#0070B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#0071B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#0072B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#0073B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#0074BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#0075BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#0076BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#0077BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#0078BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#0079BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#007AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#007BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#007CC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#007DC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#007EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#007FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#0080C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#0081C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#0082C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#0083C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#0084CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#0085CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#0086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#0087CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#0088CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#0089CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#008AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#008BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#008CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#008DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#008ED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#008FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#0091D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#0092D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#0093D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#0094D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#0096DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#0097DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#0098DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#0099DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#009ADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#009CE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#009DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#009EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#009FE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#00A0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#00A1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#00A2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#00A3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#00A4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#00A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#00A6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#00A7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#00A8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#00A9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#00AAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#00ABEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#00ACF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#00ADF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#00AEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_49_1590",
    x1: 392.089,
    y1: 340.893,
    x2: 462.485,
    y2: 335.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A0288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#5A0288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#5A0288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#5A0288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#5B0389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#5C0489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#5C048A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#5D058A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#5D058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5E068B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#5E068B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#5F078C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#5F078C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#60088D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286363,
    stopColor: "#60088D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#60098D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#61098E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#61098E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#620A8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#620A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#630B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#630B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#640C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#640C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#650D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#650D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#660E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#660E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#670F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#670F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#681093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#681094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#691194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#691195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#6A1295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#6A1296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#6B1396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#6B1396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#6C1497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#6C1497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#6D1598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#6D1698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6E1699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#6E1799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#6F1799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#6F189A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#70189A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#70199B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#71199B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#711A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#721A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#721B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#731B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#731C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#741C9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#741D9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#751D9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#751E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#761E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#761FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#771FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#7720A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#7820A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#7821A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#7921A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#7922A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#7A22A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#7A23A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#7B23A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#7B24A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713637,
    stopColor: "#7C24A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#7C25A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#7C25A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#7D25A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#7D26A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7E26A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#7E27A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#7F27A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#7F28A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#8028A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#8029A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#8029A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#812AA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#812AA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#822BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#822BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#832CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#832CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#842DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#842DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#852EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#852EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#862FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#862FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#8730AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#8731AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#8831AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8831AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_49_1590",
    x1: 177.437,
    y1: 359.393,
    x2: 228.071,
    y2: 384.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_49_1590",
    x1: 238.746,
    y1: 403.624,
    x2: 175.871,
    y2: 373.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#36035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#37035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#37045B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#38045B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#39055B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3A055C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3A065C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3B065C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3C075D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#3D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#3E085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#3F095E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#400A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#410A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#420B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#430C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#440C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#450D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#460E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#470E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#480F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#491062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#4A1062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#4B1162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#4C1163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#4C1263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#4D1263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4E1364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#4F1364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#4F1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#501465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#511565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#521565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#521665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#531666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#541766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#541766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#551867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#561867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#571967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#571968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#581A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#591B68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#5A1B69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#5A1C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#5B1C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#5C1D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#5C1D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#5D1E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#5E1E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#5F1F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#5F1F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#60206B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#61206C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#62216C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#62216C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#63226D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#64236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#65236E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#66246E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#67246E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#68256F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#69266F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#6A2670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#6B2770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#6C2870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#6D2871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#6E2971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#6F2A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#702A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#712B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#722B73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#732C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#742D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#752D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#762E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#772F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#782F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#793075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#7A3176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#7B3176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#7C3277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#7D3377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#7E3377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#7F3478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#803478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#813579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#823679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#833679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#84377A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#85387A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#86387B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#87397B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#883A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#893A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8A3B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3B7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_49_1590",
    x1: 80.6363,
    y1: 258.619,
    x2: 229.71,
    y2: 331.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#36035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#36035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#36035A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#37045A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#38045B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#38045B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#39055B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#39055B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3A055C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#3A065C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#3B065C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#3B065C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#3C075C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#3D075D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3E085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3F095E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#3F095E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#400A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#410A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#410A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#420B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#430B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#430C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#440C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#450D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#460D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#460E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#470E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#480E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#480F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#490F62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#4A1062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#4A1062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4B1163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#4C1263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D1263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#4E1364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4F1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#501565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#511565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#521665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#531766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#541766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#551867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#561967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#571968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#581A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#591B68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#5A1C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#5B1C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#5C1D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#5D1E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#5E1E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#5F1F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#60206B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#61206C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#62216C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#63226D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#64226D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#64226D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#65236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#66236E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#66246E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#67246E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#68256E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#68256F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#69266F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#6A266F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#6A2670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#6B2770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#6C2770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6C2870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#6D2871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#6E2971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#6E2971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6F2971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#702A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#702A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#712B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#722B73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#722C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#732C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#742D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#742D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#752D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#762E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#762E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#772F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#782F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#793075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#793075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#7A3076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#7B3176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#7B3176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#7C3277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#7D3277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#7D3377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#7E3377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#7F3378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#7F3478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#803478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#813578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#813579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#823679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#833679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#83377A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#84377A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#85377A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#85387A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#86387B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#87397B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#88397B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#883A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#893A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#8A3B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#8A3B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#8A3B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3B7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_49_1590",
    x1: 601.484,
    y1: 107.795,
    x2: 771.07,
    y2: 107.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3428BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#3429BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#3529BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#352ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#352BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#362CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#362DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#362EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#372FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#3730BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#3731BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#3832BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#3833BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#3834BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#3935BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#3936BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3937BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#3A38BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#3A39BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#3A3ABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#3B3BBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#3B3CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#3B3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#3C3DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#3C3EC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#3C3FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#3D40C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#3D41C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#3D42C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#3E43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#3E44C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#3E45C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3F46C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#3F47C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3F48C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#4049C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#404AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#404BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#414CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#414DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#414EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#424FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4250C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#4251C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#4351C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#4352C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#4353C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#4454C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#4455C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#4456C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#4557C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#4558C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#4559C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#465AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#465BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#465CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#475DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#475EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#475FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#4860C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#4861C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#4862CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4963CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#4964CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4965CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#4A65CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4A66CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#4A67CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#4B68CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#4B69CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#4B6ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#4C6BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#4C6CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#4C6DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#4D6ECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#4D6FCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#4D70CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#4E71CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#4E72CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#4E73CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4F74CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4F75CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4F76CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#5077CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#5078D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#5078D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#5179D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#517AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#517BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#527CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#527DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#527ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#537FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#5380D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#5381D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#5482D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5483D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#5584D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#5585D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#5586D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#5687D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#5688D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#5689D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#578AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#578BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#578CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#588CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#588DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#588ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#598FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#5990D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#5991D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#5A92D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#5A93D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#5A94D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#5B95D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5B96D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#5B97D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5C98D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#5C99D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5C9AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#5D9BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#5D9CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#5D9DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#5E9EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#5E9FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#5EA0DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#5FA0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FA1DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_49_1590",
    x1: 16,
    y1: 575.847,
    x2: 133.636,
    y2: 575.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3428BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#3429BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#3529BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#352ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#352BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#362CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#362DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#362EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#372FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#3730BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#3731BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#3832BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#3833BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#3834BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#3935BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#3936BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3937BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#3A38BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#3A39BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#3A3ABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#3B3BBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#3B3CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#3B3DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#3C3DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#3C3EC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#3C3FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#3D40C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#3D41C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#3D42C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#3E43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#3E44C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#3E45C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3F46C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#3F47C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#3F48C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#4049C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#404AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#404BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#414CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#414DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#414EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#424FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4250C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#4251C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#4351C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#4352C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#4353C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#4454C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#4455C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#4456C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#4557C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#4558C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#4559C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#465AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#465BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#465CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#475DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#475EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#475FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#4860C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#4861C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#4862CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4963CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#4964CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4965CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#4A65CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4A66CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#4A67CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#4B68CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#4B69CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#4B6ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#4C6BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#4C6CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#4C6DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#4D6ECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#4D6FCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#4D70CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#4E71CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#4E72CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#4E73CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4F74CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4F75CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4F76CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#5077CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#5078D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#5078D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#5179D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#517AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#517BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#527CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#527DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#527ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#537FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#5380D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#5381D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#5482D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5483D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#5584D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#5585D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#5586D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#5687D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#5688D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#5689D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#578AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#578BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#578CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#588CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#588DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#588ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#598FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#5990D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#5991D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#5A92D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#5A93D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#5A94D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#5B95D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5B96D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#5B97D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5C98D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#5C99D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5C9AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#5D9BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#5D9CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#5D9DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#5E9EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#5E9FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#5EA0DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#5FA0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FA1DB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/vr.1b132ed94c18dc418b4a347c7e012c06.svg";
export { ForwardRef as ReactComponent };